var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-mob-accordion",class:{_open: _vm.isOpen}},[_c('div',{staticClass:"page-mob-accordion__title",on:{"click":function($event){$event.preventDefault();return _vm.onOpen.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.title))]),_c('CollapseTransition',[(_vm.isDesktop || _vm.isOpen)?_c('div',[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }